<h2>User List</h2>

<p>Users length: {{ users().length }}</p>

<ul>
  @for(user of users(); track $index) {
    <li>{{ user.id }} {{ user.name }}</li>
  }
</ul>

